(()=>{
  if(customElements.get('fe-falcon-camera'))return;
  customElements.define('fe-falcon-camera',class extends HTMLElement{
    connectedCallback(){
      if(this._dispose)return;
      const video=this.querySelector('video');if(!video)return;
      const mobileQuery=window.matchMedia('(max-width: 749px)');
      let inView=false,ended=false;
      const start=()=>{
        if(!inView||document.hidden||!video.src)return;
        video.muted=true;
        const pending=video.play();
        if(pending&&typeof pending.catch==='function')pending.catch(()=>{});
      };
      const sync=()=>{
        if(ended)return;
        const mobile=mobileQuery.matches;
        const desktopSrc=this.dataset.desktopVideo||'';
        const newSrc=(mobile?this.dataset.mobileVideo:desktopSrc)||desktopSrc;
        const poster=(mobile?this.dataset.mobilePoster:this.dataset.desktopPoster)||this.dataset.desktopPoster||'';
        if(poster&&video.getAttribute('poster')!==poster)video.setAttribute('poster',poster);
        if(!newSrc)return;
        if(video.dataset.activeSrc!==newSrc){
          video.pause();video.dataset.activeSrc=newSrc;
          video.src=newSrc;
          video.preload='metadata';video.load();
        }
        start();
      };
      const onVisibility=()=>{if(document.hidden){video.pause()}else{start()}};
      let observer;
      if('IntersectionObserver' in window){
        observer=new IntersectionObserver(entries=>{
          inView=entries.some(e=>e.isIntersecting);
          if(inView)sync();else video.pause();
        },{rootMargin:'160px 0px',threshold:0.01});
        observer.observe(this);
      }else{inView=true;sync()}
      mobileQuery.addEventListener?.('change',sync);
      window.addEventListener('pageshow',start);
      document.addEventListener('visibilitychange',onVisibility);
      this._dispose=()=>{
        ended=true;observer?.disconnect();video.pause();
        mobileQuery.removeEventListener?.('change',sync);
        document.removeEventListener('visibilitychange',onVisibility);
        window.removeEventListener('pageshow',start);
      };
    }
    disconnectedCallback(){this._dispose?.();this._dispose=null}
  });
})();
